let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i7uJq")).then(() => parcelRequire('j3xsn'));